import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';
import TabsPage from '../views/Etichette/EtichetteApp.vue'
// import insOrdini from '../views/InsOrdini/InsOrdini.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/homepage'
  },
  {
    path: '/etichetteApp/',
    component: TabsPage,
    children: [
      {
        path: '',
        redirect: '/etichetteApp/tab2'
      },
      {
        path: 'tab1',
        component: () => import('@/views/Etichette/Tab1Page.vue')
      },
      {
        path: 'tab2',
        component: () => import('@/views/Etichette/Tab2Page.vue')
      },
      {
        path: 'tab3',
        component: () => import('@/views/Etichette/Tab3Page.vue')
      }
    ]
  },
  {
    path: '/insOrdini',
    name: 'insOrdini',
    component: () => import('../views/InsOrdini/InsOrdini.vue')
  },
  {
    path: '/AnagraficaProdotti',
    name: 'AnagraficaProdotti',
    component: () => import('../views/Anagrafiche/AnagraficaProdotti.vue')
  },
  {
    path: '/AnagraficaClienti',
    name: 'AnagraficaClienti',
    component: () => import('../views/Anagrafiche/AnagraficaClienti.vue')
  },
  // {
  //   path: '/Login',
  //   name: 'Login',
  //   component: () => import('@/views/Login/LoginPage.vue')
  // }
  {
    path: '/homepage',
    name: 'HomePage',
    component: () => import('@/views/HomePage/HomePage.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
